module.exports = __webpack_public_path__ + "img/family-10.73eb2074.jpg";